import axios from 'axios'
import { URL } from '../../../env'
import { EDITOR_TOOLBAR } from './editorToolbar'

export default {
  data: () => ({
    formStatus: 0,
    min: 1,
    max: 0,
    slider: 0,
    isoInfo: {},
    progressModel: false,
    uploaded: false,
    categories: [],
    files: [],
    iso_message: '',
    offer: {},
    deal: {},
    iso: {},
    customToolbar: EDITOR_TOOLBAR,
  }),
  mounted() {
    axios.get(`${URL}/get_deal_for_iso/${this.$route.params.lender_id}/${this.$route.params.unique_id}`).then(res => {
      this.deal = res.data.data.offer[0]
      this.offer = res.data.data.offer[0]
      this.iso = res.data.data.iso[0]
      this.max = this.deal.lender_commission_percentage
      this.slider = this.deal.lender_commission_percentage
      axios.post(`${URL}/send_offer_accepted_email`, { deal: this.deal, iso: this.iso })
    })
    axios.get(`${URL}/api/file_category/file_categories`).then(resp => {
      this.categories = resp.data.data
    })
  },
  methods: {
    logout() {
      this.$store.dispatch('userLogout')
    },
    handleFiles() {
      const uploadedFiles = this.$refs.files.files
      for (let i = 0; i < uploadedFiles.length; i++) {
        this.files.push({ fileUploaded: uploadedFiles[i], category_id: null })
      }
      this.getImagePreviews()
    },
    getImagePreviews() {
      for (let i = 0; i < this.files.length; i++) {
        if (/\.(jpe?g|png|gif)$/i.test(this.files[i].fileUploaded.name)) {
          const reader = new FileReader()
          reader.addEventListener('load', () => {
            this.$refs['preview' + i][0].src = reader.result
          }, false)
          reader.readAsDataURL(this.files[i].fileUploaded)
        } else {
          this.$nextTick(() => {
            this.$refs['preview' + i][0].src = 'https://www.foot.com/wp-content/uploads/2017/03/placeholder.gif'
          })
        }
      }
    },
    removeFile(key) {
      this.files.splice(key, 1)
      this.getImagePreviews()
    },
    async submitFiles() {
      const vm = this
      if (vm.files.length > 0) {
        if (this.$refs.form.validate()) {
          for (let i = 0; i < vm.files.length; i++) {
            if (vm.files[i].fileUploaded.id) continue
            const formData = new FormData()
            formData.append('file', vm.files[i].fileUploaded)
            formData.append('user_id', vm.isoInfo.id)
            formData.append('deal_id', vm.deal.deal_id)
            formData.append('file_category_id', vm.files[i].category_id)
            await axios
              .post('/api/deal_file/deal_files', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
              .then(data => {
                vm.files[i].id = data['data']['id']
                vm.files.splice(i, 1, vm.files[i])
                if (data.data.success) {
                  vm.flash(data.data.message, 'success', { timeout: 4000 })
                  vm.uploaded = true
                }
              })
              .catch(() => {
                vm.flash('There was an error uploading files.', 'error', { timeout: 4000 })
              })
          }
          vm.files = []
          vm.saveUpdateSubmission()
        }
      } else {
        vm.saveUpdateSubmission()
      }
    },
    saveOfferUpdate() {
      const app = this
      axios
        .put('/api/deal_lender/deal_lenders/' + app.deal.id, {
          deal_id: this.deal.deal_id,
          lender_offer_status: 'Offer Accepted',
          lender_offer_amount: app.offer.lender_offer_amount,
          lender_payback_amount: app.offer.lender_payback_amount,
          lender_payment: app.offer.lender_payment,
          lender_factor_rate: app.offer.lender_factor_rate,
          lender_buy_rate: app.offer.lender_buy_rate,
          lender_commission_percentage: app.slider,
          lender_term: app.offer.lender_term,
        })
        .then(response => {
          if (response.data.success) {
            app.flash(response.data.message, 'success', { timeout: 3000 })
            app.submitFiles()
          }
        })
        .catch(() => {
          app.flash('There was an error', 'error', { timeout: 3000 })
        })
      axios
        .put('/api/submission/submissions/' + app.deal.deal_id, {
          deal_status: 'Request Price Adjustment',
          deal_next_processor_role: 'Credit Analyst',
        })
        .catch(() => {
          app.flash('There was an error', 'error', { timeout: 3000 })
        })
    },
    sendNotification() {
      const vm = this
      vm.progressModel = true
      axios.post('/iso_accept_offer_noti', {
        deal_id: vm.deal.deal_id,
        deal_lender_id: vm.deal.id,
        iso_message: vm.iso_message,
      })
      vm.saveNote()
    },
    saveNote() {
      const app = this
      axios
        .post('/api/submission_note/submission_notes', {
          deal_id: app.deal.deal_id,
          user_id: app.isoInfo.id,
          deal_user_note: app.iso_message,
          deal_note_type: 'Offer',
          pinned: false,
        })
        .then(() => {
          app.saveActivity()
        })
        .catch(() => {
          app.flash('Error Adding Note', 'error', { timeout: 3000 })
        })
    },
    saveActivity() {
      const app = this
      axios
        .post('/api/submission_note/submission_notes', {
          deal_id: app.deal.deal_id,
          user_id: app.isoInfo.id,
          deal_user_note: 'Offer Accepted',
          deal_note_processor_role: app.isoInfo.role,
          deal_note_type: 'Activity',
          pinned: false,
        })
        .then(() => {
          app.saveOfferUpdate()
        })
        .catch(() => {
          app.flash('Error Adding Note', 'error', { timeout: 3000 })
        })
    },
    async saveUpdateSubmission() {
      let resp
      try {
        resp = await this.$store.dispatch('deals/submissions/updateStatus', {
          id: this.deal.deal_id,
          user_id: 0,
          deal_status: 'Contract Request',
        })
        if (resp) {
          this.progressModel = false
          this.formStatus = 1
          this.logout()
          this.flash(resp.data.message, 'success', { timeout: 3000 })
        }
      } catch (error) {
        this.flash(resp.data.message, 'error', { timeout: 3000 })
      }
    },
    calculatePayment() {
      const app = this
      if (app.offer.lender_factor_rate.length > 0) {
        const commission_percentage = (app.slider / 100).toFixed(2)
        const factor_rate = (+app.offer.lender_buy_rate + +commission_percentage).toFixed(2)
        app.offer.lender_factor_rate = factor_rate
        const payback_amount = factor_rate * app.offer.lender_offer_amount
        app.offer.lender_payback_amount = payback_amount
        if (app.deal.lender_payment_type.toUpperCase() == 'DAILY') {
          app.offer.lender_payment = (payback_amount / app.offer.lender_term).toFixed(2)
        } else if (this.deal.lender_payment_type.toUpperCase() == 'WEEKLY') {
          app.offer.lender_payment = ((payback_amount / app.offer.lender_term) * 5).toFixed(2)
        }
      }
    },
  },
}
